'use strict';
module.exports = function (re) {
	return Object.prototype.toString.call(re) === '[object RegExp]';
};



//////////////////
// WEBPACK FOOTER
// ./~/is-regexp/index.js
// module id = 271
// module chunks = 0